import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=4d619f17&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=4d619f17&prod&scoped=true&lang=css"
import style1 from "./Products.vue?vue&type=style&index=1&id=4d619f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d619f17",
  null
  
)

export default component.exports